/**
 * Standardized loading indicator sizes for consistent UI across the dashboard.
 * Use these constants instead of hardcoded values to ensure consistency.
 */
export const LOADING_SIZES = {
  /** Full page loading spinners (e.g., route transitions) */
  page: 48,
  /** Section-level loading (e.g., data tables, cards) */
  section: 40,
  /** Inline loading inside buttons */
  button: 18,
  /** Small inline indicators (e.g., next to text) */
  inline: 20
} as const

/**
 * Standard stroke width for v-progress-circular components.
 */
export const LOADING_WIDTH = 2

export type LoadingSize = keyof typeof LOADING_SIZES
